<template>
    <div class="view-sensitive" @click="handleClick">
        <xc-icon :iconClass="state?'hide_icon':'detail'" class="edit-in-table"></xc-icon>
        <span class="view-sensitive-label">{{state?"隐藏":label}}</span>
    </div>
</template>

<script>
export default {
    name:'view-sensitive',
    props:{
        label:{
            type:String,
            default:'查看'
        },
        state:{//查看状态
            type:Boolean,
            default:false
        }
    },
    methods:{
        handleClick(){
            this.$emit('select-click');
        }
    }

}
</script>

<style lang="less" scoped>
    .view-sensitive{
        min-width: 44px;
        display: inline-block;
        margin-left: 6px;
        font-size: 0;

        cursor: pointer;
        .edit-in-table{
            fill: #9EA7B4;
            margin-left: -2px;
        }
        .view-sensitive-label{
            vertical-align: 1px;
            margin-left: 4px;
            font-size: 14px;
            color: #464C5B;
        }
    }
</style>
